// extracted by mini-css-extract-plugin
module.exports = {"premiumOnlyIcon":"PremiumOnlyIcon__premiumOnlyIcon__cNEeh"};